// Get stored games from localStorage
export const getStoredGames = () => {
  const storedGames = localStorage.getItem('gameHistory');
  return storedGames ? JSON.parse(storedGames) : [];
};

// Save a new game to localStorage
export const saveGame = (gameData) => {
  const games = getStoredGames();
  const newGame = {
    ...gameData,
    date: new Date().toISOString(),
    id: Date.now(),
    stats: {
      correctGuesses: gameData.roundScores.filter(round => round.score > 0).length,
      totalGuesses: gameData.roundScores.reduce((sum, round) => sum + round.guessCount, 0),
      averageGuesses: (gameData.roundScores.reduce((sum, round) => sum + round.guessCount, 0) / gameData.roundScores.length).toFixed(1),
      difficulty: gameData.difficulty,
      perfectRounds: gameData.roundScores.filter(round => round.guessCount === 1).length,
      hardestCategory: gameData.hardestCategory,
      bestStreak: gameData.bestStreak
    }
  };
  games.push(newGame);
  localStorage.setItem('gameHistory', JSON.stringify(games));
  return newGame;
};

// Clear all stored games
export const clearLeaderboard = () => {
  localStorage.removeItem('gameHistory');
}; 